import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import CvPageLayout from '../../../components/CvPageLayout';
import EmploymentForm from '../../../components/EmploymentForm';

function CvEmploymentAdd() {
  const location = useLocation();
  const isEditing = !!location.state?.id; 

  return (
    <CvPageLayout currentStep="Doświadczenie">
      <Row className="justify-content-md-center mt-3">
        <Col>
          <EmploymentForm
            backlink="/cv-career/cv-generator/section/experience"
            nextlink="/cv-career/cv-generator/section/experience/description"
            title={isEditing ? 'Edytuj doświadczenie zawodowe' : 'Dodaj doświadczenie zawodowe'}
            subtitle={isEditing ? null : 'Zacznij od swojej ostatniej pracy.'}
          />
        </Col>
      </Row>
    </CvPageLayout>
  );
}

export default CvEmploymentAdd;